import React from 'react';
import { Outlet } from 'react-router';

const Archives = () => <Outlet />;

export default Archives;
